import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES } from "@/lib/cities";

export const ServiceAreas = () => {
  const featured = CITIES.filter((c) => c.featured);

  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="py-20 md:py-32 bg-slate-50 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left intro */}
          <div className="lg:col-span-5">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
              Service Areas
            </p>
            <h2 className="font-display mt-3 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
              Proudly serving <span className="text-blue-600">Ohio.</span>
            </h2>
            <p className="mt-5 text-base md:text-lg text-slate-600 font-medium leading-relaxed">
              ClearView is local. We know Ohio homes, Ohio weather, and what it
              takes to keep your siding, concrete, and gutters looking their
              best. Tap any city below to see services in your area.
            </p>

            <div className="mt-8 flex items-center gap-3 text-sm">
              <div className="h-9 w-9 rounded-xl bg-blue-600 text-white grid place-items-center">
                <MapPin className="h-4 w-4" />
              </div>
              <div>
                <div className="font-bold text-slate-900">15+ cities served</div>
                <div className="text-slate-500 font-medium">
                  Same-week scheduling across NE Ohio
                </div>
              </div>
            </div>
          </div>

          {/* Right city grid */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {featured.map((city) => (
                <Link
                  key={city.slug}
                  to={`/areas/${city.slug}`}
                  data-testid={`area-${city.slug}`}
                  className="group relative bg-white border border-slate-200 rounded-xl p-4 hover:border-blue-600 hover:shadow-md transition-all"
                >
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <div className="font-display font-extrabold text-slate-900 text-base md:text-lg leading-tight">
                        {city.name}
                      </div>
                      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mt-1">
                        {city.county} County
                      </div>
                    </div>
                    <ArrowRight className="h-4 w-4 text-slate-300 group-hover:text-blue-600 group-hover:translate-x-0.5 transition-all shrink-0" />
                  </div>
                </Link>
              ))}
            </div>

            <p className="mt-5 text-xs font-medium text-slate-500">
              Don't see your town? We probably still serve it —{" "}
              <a href="#contact" className="text-blue-600 font-bold hover:underline">
                request a quote
              </a>{" "}
              and we'll confirm.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
